module.exports = __webpack_public_path__ + "static/media/HOW DOES STUDENT DASHBOARD WORKS.2bb963aa.png";